import React, { useId } from 'react'
import { SimpleGrid, Text } from '@chakra-ui/react';
import { Card } from './Card';


export const Category = ({ category, webs }) => {
    console.log(webs)
    return (
        <>
            <Text fontSize='4xl' >{category}</Text>
            <SimpleGrid columns={[1, 3]} spacing={4} mt={8}>
                {
                    webs.map((web) => (
                        <Card
                            id={web.id}
                            title={web.title}
                            description={web.description}
                            cover={web.cover}
                            url={web.url}
                            category={web.category}
                            stargazers_count={web.stargazers_count
                            }
                        />
                    ))
                }
            </SimpleGrid>
        </>
    )
}
